<template>
  <div>
    <BaseFrame
      saveText='保存'
      :logText='logText'
      :infosArr='titleInfo'
      :idText='idText'
      :id='id'
      @save='handleSave'
      @hanldeLog='getRecord'
      @clear="clearAll"
      :logData='records'
    >
      <div slot="content" >
          <div class='cardContainer'>
            <lk-card title='成本相互作用'>
              <lk-form
                :label-width='134'
                label-position="right"
                :rules="formRule"
                :model="formInfo"
                ref="interactionForm"
              >
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label="化学成分1:" prop='chemistryT'>
                      <lk-input placeholder='请输入' :maxlength="50"  v-model.trim="formInfo.chemistryT" :disabled="able"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='7' offset="1">
                    <lk-form-item label="成分分类1:" prop='chemistryTypeT'>
                      <lk-input placeholder='请输入' :maxlength="50" v-model.trim="formInfo.chemistryTypeT"></lk-input>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label="化学成分2:" prop='chemistryS'>
                      <lk-input placeholder='请输入' :maxlength="50"  v-model.trim="formInfo.chemistryS" :disabled="able"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='7' offset="1">
                    <lk-form-item label="成分分类2:" prop='chemistryTypeS'>
                      <lk-input placeholder='请输入' :maxlength="50"  v-model.trim="formInfo.chemistryTypeS"></lk-input>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='7'>
                    <lk-form-item label="合用评级:" prop='rate'>
                      <lk-select v-model="formInfo.rate" clearable filterable>
                        <lk-option v-for="rate in sharedRateList" :key="rate.id" :value="rate.id">{{rate.name}}</lk-option>
                      </lk-select>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='20'>
                    <lk-form-item label="相互作用内容:" prop='description'>
                      <lk-input
                        v-model="formInfo.description"
                        type="textarea"
                        :autosize='true'
                        size="small"
                        :maxlength="500"
                        clearable
                        placeholder="请输入，最多支持500个中文字符"
                      />
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </lk-card>
          </div>

      </div>
    </BaseFrame>
      <DTPModal v-model.trim="clearModal" content='重置将取消当前所做更改。' @confirm='reset' type='alert'></DTPModal>
      <DTPModal v-model.trim="coverModal" content='已录入此相互作用信息，是否覆盖内容？' @confirm='handleSave(1)' type='alert'></DTPModal>
  </div>
</template>

<script>
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import DTPModal from '../../../components/DTPModal.vue';
import tools from '../../../services/tools';
import utils from '../../../libs/utils';
import goodsMixins from '../../../mixins/goodsMixins';


export default {
  name: 'MedicationEdit',
  mixins: [goodsMixins],
  components: {
    BaseFrame,
    DTPModal,
  },
  watch: {
  },
  computed: {
    able() {
      return !!this.$route.params.id;
    },
  },
  data() {
    return {
      records: [],
      idText: '',
      id: '',
      logText: '操作日志',
      titleInfo: [],
      clearModal: false,
      coverModal: false,
      formInfo: {},
      formRule: {
        chemistryT: [
          {
            required: true,
            message: '请输入',
          },
        ],
        chemistryTypeT: [
          {
            required: true,
            message: '请输入',
          },
        ],
        chemistryS: [
          {
            required: true,
            message: '请输入',
          },
        ],
        chemistryTypeS: [
          {
            required: true,
            message: '请输入',
          },
        ],
        description: [
          {
            required: true,
            message: '请输入',
          },
        ],
        rate: [
          {
            required: true,
            message: '请输入',
            trigger: 'change',
            type: 'number',
          },
        ],
      },
      sharedRateList: [
        {
          id: 1,
          name: '关注',
        },
        {
          id: 2,
          name: '不推荐合用',
        },
        {
          id: 3,
          name: '谨慎合用',
        },
        {
          id: 4,
          name: '禁忌合用',
        },
      ],
    };
  },
  methods: {
    clearAll() {
      this.clearModal = true;
    },
    reset() {
      if (this.able) {
        this.getData();
      } else {
        this.formInfo = {};
      }
      this.clearModal = false;
    },
    getRecord() {
      const params = {
        bizId: this.$route.params.id,
        bizType: 4,
      };
      tools.interactionRecord(params).then((res) => {
        if (res.data.status === 200) {
          this.records = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      tools.interactionInfo({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.formInfo = data;
          this.idText = '相互作用ID';
          this.id = `${data.id}`;
          this.titleInfo = [
            { name: '创建人：', value: data.createUserName },
            { name: '创建时间：', value: data.createTime ? utils.exchangeTimeToSecond(data.createTime) : '' },
            { name: '最后修改人：', value: data.modifiedUserName },
            { name: '最后修改时间：', value: data.modifiedTime ? utils.exchangeTimeToSecond(data.modifiedTime) : '' },
          ];
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    handleSave(cover = 2) {
      this.$refs.interactionForm.validate((valid) => {
        if (!valid) {
          this.$Message.error('请填写完整数据');
        } else {
          const temp = utils.deepClone(this.formInfo);
          temp.cover = cover;
          const saveFunc = this.$route.params.id ? tools.interactionEdit : tools.interactionAdd;
          saveFunc(temp).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('保存成功');
              this.$router.push({ name: 'interactionList' });
            } else if (res.data.status === 43001) {
              this.coverModal = true;
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
  },
  mounted() {
    this.logText = this.$route.params.id
      ? '操作日志'
      : '';
    if (this.$route.params.id) {
      this.getData();
    }
  },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
</style>
